__turbopack_context__.v({
  "group": "LeaderboardAgeSection-module__IXlRxq__group",
  "groupLabel": "LeaderboardAgeSection-module__IXlRxq__groupLabel" + " " + __turbopack_context__.i(917291)["lbMetaLabel"],
  "rowList": "LeaderboardAgeSection-module__IXlRxq__rowList",
  "section": "LeaderboardAgeSection-module__IXlRxq__section",
  "sectionTitle": "LeaderboardAgeSection-module__IXlRxq__sectionTitle" + " " + __turbopack_context__.i(917291)["lbMetaLabel"],
});
